import * as React from 'react';
import 'react-phone-number-input/style.css'
import '../../styles/phoneInput.css'
import { Typography, makeStyles } from '@material-ui/core';
import { TextFieldLabelPosition, TextFieldProps } from './TextField';
import PhoneInput, { parsePhoneNumber, formatPhoneNumber, formatPhoneNumberIntl, getCountryCallingCode } from 'react-phone-number-input'
import { CheckOutStateContext } from '../../providers/CheckOutStateContextProvider';

const useStyles = makeStyles({
    label: {
        textAlign: 'left',
    },
    phoneInput: {
        fontFamily: "'Roboto', 'Helvetica', 'Arial', 'sans-serif'",
        fontSize: '20px !important',
    },
});

export type PhoneTextFieldChangeHandler = (newValue: string, country: string, phone: string, countryCode: string) => any;


export interface PhoneTextFieldProps {
    country: string | null;
    type: string | null;
    label: string | null;
    text: string;
    width: number;
    disabled: boolean;
    labelPosition: TextFieldLabelPosition;
    onChangeHandler: PhoneTextFieldChangeHandler;
}

const PhoneTextField = (props: PhoneTextFieldProps) => {
    const { country, type, label, text, width, onChangeHandler } = props;
    const [value, setValue] = React.useState<string>(text);
    const checkOutState = React.useContext(CheckOutStateContext);
    const classes = useStyles({ primary_main_color: checkOutState.state.skin.primary_main_color, 
        primary_light_color: checkOutState.state.skin.primary_light_color, primary_dark_color: checkOutState.state.skin.primary_dark_color });

    const handleChange = (newValue: string) => {
        try {
            setValue(newValue.trim());
        
            if (newValue.trim() !== "") {
                var phone = parsePhoneNumber(newValue);
            
                if (phone !== undefined) {
                    if (phone.country !== undefined) {
                        onChangeHandler(newValue, getCountryCallingCode(phone.country), phone.nationalNumber, phone.country!!);
                    }
                    else {
                        onChangeHandler(newValue, "", phone.nationalNumber, "");
                    }
                }
            }
        }
        catch (exception) {

        }
    };

    return (
        <div>
            <div className={classes.label}>
                <Typography id="phone-input-label" variant="caption">
                    {label}
                </Typography>
            </div>
            <PhoneInput
                className={classes.phoneInput}
                aria-labelledby="phone-input-label"
                countryOptionsOrder={[country === null ? "US" : country]}
                limitMaxLength={true}
                international={false}
                defaultCountry={country === null ? "US" : country}
                value={value}
                onChange={handleChange} />
        </div>
    );
}

export default PhoneTextField;